import styled from "styled-components";

export const Container = styled.section`
  margin-top: 15rem;
  display: flex;
  flex-direction: column;
  gap: 4rem;
  font-family: 'Fira Code', monospace;
  
  .about-text p {
    margin-bottom: 2rem;
    font-size: 1.6rem;
    line-height: 1.8;
    color: #d1d5db;
  }

  .hard-skills{
    margin-top: 2rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2rem;
  }
  
  .hability{
    display: flex;
    flex-direction: column;
    align-items: center;
    background: var(--terminal-header);
    padding: 1.5rem;
    border-radius: 8px;
    border: 1px solid var(--terminal-border);
    transition: 0.25s;

    &:hover {
      border-color: var(--green);
      transform: scale(1.1);
    }

    img{
      width: 4rem;
    }
  }

  h2{
    font-size : 4rem;
    margin-bottom: 3rem;
    color: var(--green);
    &::after {
      content: "()";
      opacity: 0.5;
    }
  }

  h3{
    margin-top: 3rem;
    margin-bottom: 2rem;
    color: var(--blue);
    font-size: 2.2rem;
  }

  @media (max-width: 960px){
    text-align: center;
    .hard-skills{
      justify-content: center;
    }
  }
`;
